import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

import { cn } from "@/shared/lib";

import { Button } from "../button";

type BlockErrorProps = {
  // Что не загрузилось; по умолчанию — «Не удалось загрузить».
  title?: ReactNode;
  // Подробности (текст ошибки API).
  message?: string | null;
  retrying: boolean;
  onRetry: () => void;
  className?: string;
};

// Блок не загрузился: на его месте — что случилось и «Попробовать снова», а не пустое место.
export const BlockError = ({ title, message, retrying, onRetry, className }: BlockErrorProps) => (
  <div
    role="alert"
    className={cn(
      "flex flex-col items-start gap-2.5 rounded-xl border border-bad/40 bg-bad/10 px-4.5 py-4",
      className,
    )}
  >
    <p className="font-semibold">{title ?? <Trans>Could not load</Trans>}</p>
    {message != null && message !== "" && <p className="text-sm text-muted">{message}</p>}
    <Button variant="outline" size="sm" loading={retrying} onClick={onRetry}>
      <Trans>Try again</Trans>
    </Button>
  </div>
);
